import React from 'react';
import styles from './Confirm.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';

const Confirm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { formValues } = location.state || {};

  const handleBack = () => {
    navigate('/contact', { state: { formValues } });
  };

  const handleSubmit = () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formValues)
    };

    fetch('https://cellnology.jp/3daylp/001/mail/mail.php', requestOptions)
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
  };
  

  return (
    <section className={styles.confirm_area}>
      <h2>Confirm</h2>
      {formValues ? (
        <div className={styles.contents}>
          <h3>以下の内容でフォームを送信します。よろしいですか？</h3>
          <p>Name<br />{formValues.name}</p>
          <p>Corporate Name<br />{formValues.corporateName}</p>
          <p>Email<br />{formValues.email}</p>
          <p>Package<br />{formValues.package}</p>
          {formValues.content && <p>Content<br />{formValues.content}</p>}
          <div className={styles.btn_wrapper}>
            <Button variant="contained" onClick={handleBack}>Back</Button>
            <Button variant="contained" onClick={handleSubmit} href='/3daylp/001/complete'>Submit</Button>
          </div>
        </div>
      ) : (
        <p>No data available.</p>
      )}
      
    </section>
  );
};

export default Confirm;

